import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { hasAnySim } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoPergunta08Model } from './model-consultaSeguimentoPergunta08'
import { isPergunta08ForaAlcanceAllNao } from './utils-consultaSeguimentoPergunta08'

export const PERGUNTA_08_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta08Model> = {
  PERGUNTA_08_HEADER: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: 'PERGUNTA_08_SE_INTERESSA_POR',
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_08_RESPONDE_PERGUNTAS',
      },
    ],
  },
  PERGUNTA_08_SE_INTERESSA_POR: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_08_RESPONDE_PERGUNTAS',
      },
    ],
    dependsOn: 'PERGUNTA_08_HEADER',
  },
  PERGUNTA_08_RESPONDE_PERGUNTAS: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: 'PERGUNTA_08_FORA_ALCANCE',
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_08_HEADER',
  },
  PERGUNTA_08_FORA_ALCANCE: {
    scrollConditions: [
      {
        if: hasAnySim,
        scrollTo: 'PERGUNTA_08_RESPONDE_CRIANCAS',
      },
      {
        if: isPergunta08ForaAlcanceAllNao,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_08_RESPONDE_PERGUNTAS',
  },
  PERGUNTA_08_RESPONDE_CRIANCAS: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_08_FORA_ALCANCE',
  },
}
